import React from 'react';
import BaseContainer from 'app/containers/BaseContainer';
import { observer } from 'mobx-react';
import { MainMenu } from './MainMenu';
import { RouteComponentProps } from 'react-router-dom';

const VerlinkungenContainer = observer((props: RouteComponentProps) => {
	const links = [
		{
			groupTitle: 'AMIS.NOW',
			groupLinks: [
				{
					title: 'Funktionalitäten | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/funktionalitaeten.html',
				},
				{
					title: 'Feedback | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/fragen-und-support.html',
				},
				{
					title: 'Fragen und Support | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/content/dam/onemarketing/dechap/common/amis/documents/agentur-und-vertrieb/beratung-und-verkauf/amis-now/der-umzug/20241030_umzugscheckliste.pdf',
				},
				{
					title: 'Allianz Akademien',
					url: 'https://akademien.allianz.de/app.html#!/training/947102548',
				},
				{
					title: 'AAA Portal',
					url: 'https://aaa-portal.allianz.de/ilp/pages/catalogsearch.jsf?q=%7B!q.op%3DAND%7D%20*:*&fq=%7B!tag%3DclassificationIds_52006980%7D%20classificationIds_52006980:(1%2F52006980%2F57662413%2F)&sidebarExpanded=true&rows=15',
				},
				{
					title: 'Videothek',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/videos.html',
				},
				{
					title: 'AMIS.NOW – Der Umzug | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/der-umzug.html',
				},
				{
					title: 'Migration von Dokumenten | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/der-umzug/migration-von-dokumenten.html',
				},
				{
					title: 'Spezialisten | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/der-umzug/spezialisten.html',
				},
				{
					title: 'Nutzungsbedingungen',
					url: 'https://amisonline.allianz.de/content/dam/onemarketing/dechap/common/amis/documents/agentur-und-vertrieb/beratung-und-verkauf/amis-now/der-umzug/Key-fact-Chart_GKDN_Nutzungsbed_Hoch_final_2.pdf',
				},
				{
					title: 'Datenschutzprozess in AMIS.NOW | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/beratung-und-verkauf/amis-now/datenschutz.html',
				},
			],
		},
		{
			groupTitle: 'Agentur der Zukunft',
			groupLinks: [
				{
					title: 'Agentur der Zukunft | amisonline.allianz.de',
					url: 'https://amisonline.allianz.de/res/service/direct.dechap.html?uri=/agentur-und-vertrieb/organisation-und-finanzen/steuerung/agentur-der-zukunft.html?AZMEDID=Mailings_MP-Newsletter_TH-DigitaleVertriebssteuerung_PA-ABV_KA-0000_TP-Textlink_LA-Textlink_LD-dvsaappde#anlaesse',
				},
				{
					title: 'Leitfaden',
					url: `https://amisonline.allianz.de/agentur-und-vertrieb/organisation-und-finanzen/steuerung/agentur-der-zukunft/was-ist-adz.html#kpi`,
				},
				{
					title: 'Podcast - Unfall als Game-Changer der Herbstwerbung',
					url: 'https://amisonline.allianz.de/res/service/direct.dechap.html?uri=/agentur-und-vertrieb/organisation-und-finanzen/steuerung/agentur-der-zukunft/adz_fuer_vbl.html?AZMEDID=Mailings_MP-Newsletter_TH-EMAIL_PA-ABV_KA-10.10.2025_TP-Textlink_LA-Textlink_LD-AdZPodcastDVS',
				},
			],
		},
		{
			groupTitle: 'Weitere',
			groupLinks: [
				{
					title: 'Erfassungskriterien',
					url: 'https://amisonline.allianz.de/agentur-und-vertrieb/organisation-und-finanzen/finanzen/geschaeftsplaene.html',
				},
				{
					title: 'Primavista',
					url: 'https://primavista.allianz-people.de/login?ReturnUrl=%2F',
				},
				{
					title: 'ProGress',
					url: 'https://avc-portal.srv.allianz/Citrix/SmartCardWeb/',
				},
			],
		},
	];

	return (
		<BaseContainer sideMenu={<MainMenu {...props} />} navbar={<div>Verlinkungen</div>}>
			<section className="section">
				<div className="content">
					<h4>Nützliche Verlinkungen</h4>
					<p>
						Über diese Links gelangen Sie direkt zur jeweiligen Anmeldeseite. <br />
						Progress und Erfassungskriterien funktionieren nur im Allianz-Netz.
					</p>

					{links.map((group, i) => (
						<div key={i}>
							<strong>{group.groupTitle}</strong>
							<ul className="links-list">
								{group.groupLinks.map((link, j) => (
									<li key={j}>
										<a href={link.url} title={link.title} target="_blank" rel="noreferrer">
											{link.title}
										</a>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</section>
		</BaseContainer>
	);
});

export default VerlinkungenContainer;
